export default __webpack_public_path__ + "static/media/maalavidaa.3bd4cf4b.png";